const state = {
    item: {},
    approvals: {
        data: [],
        total: 0
    }
};

const getters = {
    item: (state) => state.item,
    approvalLogs: (state) => state.approvals,
};


const actions = {
    /* Item Header*/
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/lmu-adhoc/approval-request`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/lmu-adhoc/approval-request/${params}`)
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/lmu-adhoc/approval-request`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/lmu-adhoc/approval-request/${data.id}`, data)
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItemStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`/api/lmu-adhoc/${data.id}/status`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/lmu-adhoc/approval-request`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },

    /* Line Item*/
    async getLineItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/lmu-adhoc/approval-request-item`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getLineItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/lmu-adhoc/approval-request-item/${params.id}`)
                .then(response => {
                    commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createLineItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/lmu-adhoc/approval-request-item`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createMultipleLineItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/lmu-adhoc/approval-request-multiple-item/${data.lmu_approval_request_id}`, {
                line_items: data.line_items
            })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateLineItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/lmu-adhoc/approval-request-item/${data.id}`, data)
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteLineItems({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/lmu-adhoc/approval-request-item`, {
                    data: {
                        ids: data.ids,
                        lmu_approval_request_id: data.lmu_approval_request_id
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },

    /* Approval */
    async getNextApprover({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/approval/next-approver`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getApprovalLogs({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/approval-request/approval-logs`, {params:params})
                .then(response => {
                    commit('setApprovalLogs', response.data.data)
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createApprovalLog({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/approval-request/approval-logs`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    /* Approval Request Form */
    async submitApprovalRequest({commit}, data){
        let formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
            if(!['photos', 'line_items'].includes(key)) {
                formData.append(key, value ? value : '');
            }
        }

        formData.append('line_items', JSON.stringify(data.line_items));
        if(data.photos && data.photos.length) {
            for(let i = 0; i < data.photos.length; i++){
                formData.append(`photos[${i}]`, data.photos[i]);
            }
        }

        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/lmu-adhoc/approval-request-form`, formData)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    /**/
    async getAttachmentsItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/approval-request/attachments`, { params: params })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => reject(error));
        });
    },

    /* Export Approval Request */
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/lmu-adhoc/approval-request/export`, { params: params, responseType: 'blob' })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};


const mutations = {
    setItem(state, data) {
        state.item = data;
    },
    setApprovalLogs(state, data) {
        state.approvals.data = data.items;
        state.approvals.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}